/**
 * Footer - 门户页脚组件
 * 
 * 简洁设计，透明背景，适配明暗模式
 */

import React from 'react';
import { useI18n } from '../../i18n';

const Footer: React.FC = () => {
  const { t } = useI18n();
  
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="mt-auto py-6">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center space-y-3">
          {/* Logo */}
          <div className="transform transition-all duration-300 hover:scale-105 opacity-50 hover:opacity-80">
            <img 
              src="/logo_24.svg" 
              alt="Unilumin Logo" 
              className="h-5 dark:brightness-200"
            />
          </div>
          
          {/* Copyright */}
          <p className="text-xs text-gray-500 dark:text-gray-400 font-light tracking-wide">
            © {currentYear} {t('footer.copyright')} | {t('footer.design')}: Zora
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;